import Crafting from '../../../../wttrpg/Crafting';

export default {
    DWARVEN_AXE: {
        name: 'Dwarven Axe',
        DC: 24,
        craftTime: '12 Hours',
        ingredients: [
            { component: Crafting.MAHAKAMAN_STEEL.item, amount: 3 },
            { component: Crafting.HARDENED_TIMBER.item, amount: 4 },
            { component: Crafting.HARDENED_LEATHER.item, amount: 2 },
            { component: Crafting.ETCHING_ACID.item, amount: 4 },
            { component: Crafting.SHARPENING_GRIT.item, amount: 1 },
            { component: Crafting.RIVER_CLAY.item, amount: 2 },
            { component: Crafting.COAL.item, amount: 3 },
        ],
        investment: 555,
        cost: 1110,
    },
    DWARVEN_CLEAVER: {
        name: 'Dwarven Cleaver',
        DC: 19,
        craftTime: '10 Hours',
        ingredients: [
            { component: Crafting.MAHAKAMAN_STEEL.item, amount: 2 },
            { component: Crafting.HARDENED_TIMBER.item, amount: 1 },
            { component: Crafting.LEATHER.item, amount: 1 },
            { component: Crafting.SHARPENING_GRIT.item, amount: 1 },
            { component: Crafting.DRAKE_OIL.item, amount: 1 },
            { component: Crafting.RIVER_CLAY.item, amount: 5 },
        ],
        investment: 374,
        cost: 7550,
    },
    DWARVEN_HEAVY_CROSSBOW: {
        name: 'Dwarven Heavy Crossbow',
        DC: 24,
        craftTime: '12 Hours',
        ingredients: [
            { component: Crafting.HARDENED_TIMBER.item, amount: 5 },
            { component: Crafting.MAHAKAMAN_STEEL.item, amount: 3 },
            { component: Crafting.HARDENED_LEATHER.item, amount: 2 },
            { component: Crafting.THREAD.item, amount: 4 },
            { component: Crafting.OGRE_WAX.item, amount: 5 },
            { component: Crafting.DARK_IRON.item, amount: 1 },
        ],
        investment: 632,
        cost: 1274,
    },
    ELVEN_GLAIVE: {
        name: 'Elven Glaive',
        DC: 19,
        craftTime: '10 Hours',
        ingredients: [
            { component: Crafting.HARDENED_TIMBER.item, amount: 6 },
            { component: Crafting.DARK_STEEL.item, amount: 4 },
            { component: Crafting.STEEL.item, amount: 1 },
            { component: Crafting.LEATHER.item, amount: 4 },
            { component: Crafting.FEATHERS.item, amount: 3 },
            { component: Crafting.SHARPENING_GRIT.item, amount: 2 },
            { component: Crafting.ESTER_GREASE.item, amount: 4 },
        ],
        investment: 692,
        cost: 1386,
    },
    ELVEN_MESSER: {
        name: 'Elven Messer',
        DC: 19,
        craftTime: '10 Hours',
        ingredients: [
            { component: Crafting.HARDENED_TIMBER.item, amount: 2 },
            { component: Crafting.LEATHER.item, amount: 3 },
            { component: Crafting.DARK_STEEL.item, amount: 3 },
            { component: Crafting.SILK.item, amount: 1 },
            { component: Crafting.SHARPENING_GRIT.item, amount: 1 },
            { component: Crafting.ETCHING_ACID.item, amount: 1 },
        ],
        investment: 446,
        cost: 892,
    },
    ELVEN_TRAVEL_BOW: {
        name: 'Elven Travel Bow',
        DC: 22,
        craftTime: '11 Hours',
        ingredients: [
            { component: Crafting.HARDENED_TIMBER.item, amount: 4 },
            { component: Crafting.THREAD.item, amount: 4 },
            { component: Crafting.WAX.item, amount: 4 },
            { component: Crafting.FIFTH_ESSENCE.item, amount: 1 },
            { component: Crafting.LEATHER.item, amount: 1 },
            { component: Crafting.FEATHERS.item, amount: 3 },
            { component: Crafting.BEAST_BONES.item, amount: 2 },
            { component: Crafting.DARK_STEEL.item, amount: 1 },
            { component: Crafting.ESTER_GREASE.item, amount: 5 },
            { component: Crafting.ETCHING_ACID.item, amount: 3 },
        ],
        investment: 432,
        cost: 862,
    },
    GNOMISH_STAFF: {
        name: 'Gnomish Staff',
        DC: 22,
        craftTime: '11 Hours',
        ingredients: [
            { component: Crafting.HARDENED_TIMBER.item, amount: 6 },
            { component: Crafting.FIFTH_ESSENCE.item, amount: 5 },
            { component: Crafting.DARKENING_OIL.item, amount: 3 },
            { component: Crafting.DARK_STEEL.item, amount: 1 },
            { component: Crafting.DOUBLE_WOVEN_LINEN.item, amount: 1 },
        ],
        investment: 682,
        cost: 1364,
    },
    HALFLING_RONDEL: {
        name: 'Halfling Rondel',
        DC: 19,
        craftTime: '10 Hours',
        ingredients: [
            { component: Crafting.DARK_STEEL.item, amount: 2 },
            { component: Crafting.HARDENED_TIMBER.item, amount: 1 },
            { component: Crafting.HARDENED_LEATHER.item, amount: 1 },
            { component: Crafting.SHARPENING_GRIT.item, amount: 3 },
            { component: Crafting.DARKENING_OIL.item, amount: 1 },
            { component: Crafting.ESTER_GREASE.item, amount: 2 },
        ],
        investment: 364,
        cost: 726,
    },
    MAHAKAMAN_MARTELL: {
        name: 'Mahakaman Martell',
        DC: 22,
        craftTime: '11 Hours',
        ingredients: [
            { component: Crafting.MAHAKAMAN_STEEL.item, amount: 5 },
            { component: Crafting.HARDENED_TIMBER.item, amount: 3 },
            { component: Crafting.HARDENED_LEATHER.item, amount: 2 },
            { component: Crafting.WOLF_HIDE.item, amount: 1 },
            { component: Crafting.SHARPENING_GRIT.item, amount: 1 },
            { component: Crafting.ESTER_GREASE.item, amount: 3 },
            { component: Crafting.DRAKE_OIL.item, amount: 2 },
            { component: Crafting.RIVER_CLAY.item, amount: 4 },
            { component: Crafting.LINEN.item, amount: 1 },
        ],
        investment: 675,
        cost: 1350,
    },
    METEORITE_SWORD: {
        name: 'Meteorite Sword',
        DC: 20,
        craftTime: '10 Hours',
        ingredients: [
            { component: Crafting.HARDENED_TIMBER.item, amount: 2 },
            { component: Crafting.HARDENED_LEATHER.item, amount: 2 },
            { component: Crafting.METEORITE.item, amount: 5 },
            { component: Crafting.SHARPENING_GRIT.item, amount: 2 },
            { component: Crafting.ETCHING_ACID.item, amount: 2 },
            { component: Crafting.ESTER_GREASE.item, amount: 1 },
        ],
        investment: 650,
        cost: 1312,
    },
    VRIHEDD_CAVALRY_SWORD: {
        name: 'Vrihedd Cavalry Sword',
        DC: 24,
        craftTime: '12 Hours',
        ingredients: [
            { component: Crafting.HARDENED_TIMBER.item, amount: 2 },
            { component: Crafting.SILK.item, amount: 1 },
            { component: Crafting.DARK_STEEL.item, amount: 4 },
            { component: Crafting.SHARPENING_GRIT.item, amount: 3 },
            { component: Crafting.ESTER_GREASE.item, amount: 4 },
            { component: Crafting.RIVER_CLAY.item, amount: 4 },
        ],
        investment: 558,
        cost: 1117,
    },
}

// {
//     name: '',
//     DC: 25,
//     craftTime: '10 Hours',
//     ingredients: [
//         { component: Crafting..item, amount: 1 },
//         { component: Crafting..item, amount: 2 },
//     ],
//     investment: ,
//     cost: ,
// },